import { useEffect } from 'react';
import { useNotification } from '@/components/notifications';
import {
  CONNECT_PROVIDER_LABELS,
  subscribeToConnectResults,
} from '@/utils/oauth-connect-signal';

/**
 * Confirm a finished consent round-trip in the tab that started it.
 *
 * Consent completes in a popup that closes itself, so without this the user
 * watches a window disappear and has no confirmation anything happened.
 */
export const useConnectResultToast = (): void => {
  const notification = useNotification();

  useEffect(
    () =>
      subscribeToConnectResults(({ provider, connected }) => {
        const label = CONNECT_PROVIDER_LABELS[provider] ?? provider;
        if (connected) {
          notification.success?.(`${label} connected`);
        } else {
          notification.error(`${label} authorization did not complete`);
        }
      }),
    [notification],
  );
};
